export default __webpack_public_path__ + "static/media/martin_jump2.083d130e.jpg";